import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/.pnpm/next@16.2.6_@babel+core@7.29.0_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/.pnpm/next@16.2.6_@babel+core@7.29.0_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/app/auth/forgot/_form.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/assets/logo.png");
